
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { AdminErrorStateProps } from './types';

const AdminErrorState = ({ error, onRetry }: AdminErrorStateProps) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-8 text-center">
        <div className="rounded-full bg-destructive/10 p-4 mb-4">
          <AlertTriangle size={40} className="text-destructive" />
        </div>
        <h3 className="text-xl font-semibold mb-2">Error Loading Administrators</h3>
        <p className="text-muted-foreground mb-4">
          {error?.message || 'An unexpected error occurred while fetching administrators.'}
        </p>
        <Button onClick={onRetry}>
          <RefreshCw className="h-4 w-4 mr-2" />
          Try Again
        </Button>
      </CardContent>
    </Card>
  );
};

export default AdminErrorState;
